import React, { useMemo, useState } from "react";
import { useAppSelector } from "../../store";
import { getFullState } from "../../store/slices/auth/auth.slice";
import { Alert, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { notifyError } from "../../utils/NotifyError";
import { IError } from "../../utils/getErrorMessage";
import { useResendVerifyEmailMutation } from "../../store/services/auth/auth.service";
import { format } from "date-fns";
import ButtonComponent from "../ButtonComponent";
const EMAIL_VERIFY_LIMIT = 3;
const MAINTENANCE_MODE = JSON.parse(process.env.REACT_APP_MAINTENANCE_MODE || "{}");

const Banner = (): React.ReactElement | null => {
	const { isLoggedIn, user } = useAppSelector(getFullState);
	const [callResendVerification, { isLoading: isVerifying }] = useResendVerifyEmailMutation();
	const [isBannerClosed, setIsBannerClosed] = useState(false);
	const hasReachedVerificationLimit = useMemo(() => user && user.email_verify_count === EMAIL_VERIFY_LIMIT, [user]);

	const handleResendEmail = () => {
		callResendVerification({}).then(({ data, error }) => {
			if (data) {
				toast.success("Verification email was sent successfully", { autoClose: 3000 });
			}
			if (error) {
				notifyError(error as IError);
			}
		});
	};
	const handleCloseBanner = () => {
		setIsBannerClosed(true);
	};

	if (isLoggedIn && user && !user.email_verified) {
		return (
			<Alert
				style={{ position: "relative", zIndex: 2 }}
				severity="warning"
				action={
					<ButtonComponent
						variant={"contained"}
						color={"primary"}
						size="small"
						onClick={handleResendEmail}
						disabled={hasReachedVerificationLimit || isVerifying}
						text={"Resend Email"}
						loading={isVerifying}
					/>
				}
			>
				{hasReachedVerificationLimit
					? "Limit reached for resending verification email, please contact support"
					: "Unverified Account, Please check your email inbox for a verification link to activate your account"}
			</Alert>
		);
	}
	if (MAINTENANCE_MODE.isActive && !isBannerClosed) {
		const Message =
			MAINTENANCE_MODE.message ||
			`Our website is currently undergoing scheduled maintenance to improve your experience. We expect to be back
\t\t\t\t\tonline by ${format(MAINTENANCE_MODE.overBy, "LLL d, yyy, hh:mm aa")}`;
		return (
			<Alert
				severity="warning"
				style={{
					position: "fixed",
					top: 0,
					zIndex: 10000
				}}
				onClose={handleCloseBanner}
			>
				<Typography>{Message}</Typography>
			</Alert>
		);
	}
	return null;
};

export default Banner;
